"use client";

import { getDocsNav } from "@/src/lib/docs/docs";
import { kClientPaths } from "@/src/lib/clientHelpers/clientPaths";
import { cn } from "@/src/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function DocsSidebar(props: {
  className?: string;
  onNavigate?: () => void;
}) {
  const pathname = usePathname();
  const docs = getDocsNav();

  return (
    <nav className={cn("flex flex-col gap-1", props.className)}>
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-2 px-2">
        Documentation
      </p>
      {docs.map((doc) => {
        const href = kClientPaths.docs.single(doc.slug);
        const isActive =
          pathname === href || pathname.startsWith(`${href}/`);

        return (
          <Link
            key={doc.slug}
            href={href}
            onClick={props.onNavigate}
            className={cn(
              "rounded-md px-2 py-1.5 text-sm transition-colors",
              isActive
                ? "bg-accent text-accent-foreground font-medium"
                : "text-muted-foreground hover:text-foreground hover:bg-accent/50"
            )}
          >
            {doc.title}
          </Link>
        );
      })}
    </nav>
  );
}
